import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const DEFAULT_BOOST = {
  pricePerDay: 3,
  maxSlots: 6,
  freeBoostDays: 3,
  bundles: [
    { days: 7, price: 15 },
    { days: 14, price: 28 },
    { days: 30, price: 50 },
  ],
};

// Price for a given number of days: a matching bundle wins, else days × perDay.
export const priceForDays = (settings, days) => {
  const s = settings || DEFAULT_BOOST;
  const bundle = (s.bundles || []).find((b) => Number(b.days) === Number(days));
  if (bundle) return Number(bundle.price);
  return Number(days || 0) * Number(s.pricePerDay || 0);
};

export default function useBoostSettings() {
  const [settings, setSettings] = useState(DEFAULT_BOOST);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDoc(doc(db, "settings", "boost"));
        if (snap.exists()) setSettings({ ...DEFAULT_BOOST, ...snap.data() });
      } catch (err) {
        console.warn("Boost settings fallback:", err.message);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  return { settings, loaded };
}
